<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">WPCal.io - {{ T__("Event Types") }}</h1>
        <router-link to="/event-type/add" class="page-title-action">{{
          T__("+ Create New Event Type")
        }}</router-link>

        <PremiumInfoBadge
          style="margin: -6px 0 0 10px;"
          highlight_feature="services"
        >
          <em>Free: 1 active event type<br />Plus: Unlimited</em>
        </PremiumInfoBadge>
        <AdminHeaderRight />
      </div>
      <div style="display:flex;">
        <div>
          <div class="">
            <div class="validation_errors_cont"></div>
            <div class="et-filter-cont">
              <div
                style="color: #7c7d9c; font-size: 11px; align-self: center; padding: 0 7px"
              >
                FILTER BY
              </div>
              <ul class="filters-bar">
                <li class="bf-host">
                  <span class="bf-label" style="margin-right: -35px;"
                    >Host</span
                  >
                  <TypeToSelect
                    v-if="
                      !_isEmpty(
                        $store.getters.get_managed_active_admins_for_host_filter
                      )
                    "
                    v-model="filter_options.filter_by_admin_id"
                    :options="
                      $store.getters.get_managed_active_admins_for_host_filter
                    "
                    label_field="name"
                    value_field="admin_user_id"
                    @changed-form-selected="load_page()"
                    class="no-border"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="service-list-cont">
            <div
              v-if="
                _isEmpty(grouped_service_list) && first_time_service_list_loaded
              "
              style="margin-left:10px; display:inline;"
              class="mbox"
            >
              There are no event types available.
              <router-link to="/event-type/add"
                >Create a new event type</router-link
              >
              now.
            </div>
            <div
              class="service-list-group"
              v-for="(admin_details, admin_user_id) in grouped_service_list"
              :key="admin_user_id"
            >
              <div class="service-list-group-admin-profile">
                <img
                  v-if="
                    $store.getters.get_admin_details(
                      admin_details.admin_user_id
                    ).profile_picture
                  "
                  :src="
                    $store.getters.get_admin_details(
                      admin_details.admin_user_id
                    ).profile_picture
                  "
                  width="30"
                  style="border-radius:50%;"
                  :title="
                    $store.getters.get_admin_details(
                      admin_details.admin_user_id
                    ).display_name
                  "
                />
                {{
                  admin_details.admin_user_id != 0
                    ? $store.getters.get_admin_details(
                        admin_details.admin_user_id
                      ).name
                    : "Other"
                }}
              </div>
              <div class="service-list-singles-cont">
                <div
                  class="service-list-single"
                  :class="{
                    ['clr-' + service.color]: true,
                    inactive: service.status == -1,
                    private: service.is_manage_private == 1,
                    'del-alert': show_delete_highlight(
                      'delete_highlight_service_id',
                      service.id
                    )
                  }"
                  v-for="(service, index) in admin_details.services"
                  :key="index"
                >
                  <h4>
                    <a :href="'#/event-type/edit/' + service.id"
                      ><i v-if="service.is_manage_private == 1"></i
                      >{{ service.name }}</a
                    >
                  </h4>
                  <div class="et-edit-link">
                    <a :href="'#/event-type/edit/' + service.id">{{
                      T__("EDIT")
                    }}</a>
                  </div>

                  <OverflowMenu
                    :menu_id="service.id"
                    v-model="service_overflow_menu_details"
                  >
                    <a
                      class="menu-item del-hl"
                      style="color: rgb(232, 70, 83);"
                      @click="
                        may_show_service_status_change_dialog(-2, service)
                      "
                      @mouseover="
                        set_mouseover_on_delete(
                          'delete_highlight_service_id',
                          service.id,
                          true
                        )
                      "
                      @mouseleave="
                        set_mouseover_on_delete(
                          'delete_highlight_service_id',
                          service.id,
                          false
                        )
                      "
                      >{{ T__("Delete this Event Type") }}</a
                    >
                    <div class="menu-item" style="display:flex !important;">
                      <span
                        style="color: #7c7d9c !important; font-size: 13px;"
                        >{{ T__("On/Off") }}</span
                      >
                      <OnOffSlider
                        style="margin-left:auto;"
                        v-if="
                          service_overflow_menu_details.open_menu_id ==
                            service.id &&
                            (service.status == 1 || service.status == -1)
                        "
                        :name="service.id"
                        v-model="service.status"
                        true_value="1"
                        false_value="-1"
                        @prop-slider-value-changed="
                          may_show_service_status_change_dialog($event, service)
                        "
                      />
                    </div>
                  </OverflowMenu>

                  <div class="et-meta">
                    {{ service.duration | mins_to_str }},
                    {{ service.relationship_type | relationship_type_str }}
                  </div>
                  <div
                    v-if="service.post_details.link"
                    style="display:flex; margin-top:auto;"
                  >
                    <a
                      class="view-booking-page"
                      :href="service.post_details.link"
                      target="_blank"
                      >{{ T__("View Booking Page") }}</a
                    >
                    <div style="margin-left:auto;">
                      <img
                        v-if="
                          $store.getters.get_admin_details(
                            service.admin_user_id
                          ).profile_picture
                        "
                        :src="
                          $store.getters.get_admin_details(
                            service.admin_user_id
                          ).profile_picture
                        "
                        width="30"
                        style="border-radius:50%;"
                        :title="
                          $store.getters.get_admin_details(
                            service.admin_user_id
                          ).display_name
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="help-column">
          <div>
            <div>Help docs</div>
            <ul>
              <li>
                <a
                  href="https://help.wpcal.io/en/article/where-to-find-the-event-type-booking-widget-shortcode-and-how-to-use-it-1fuyala/?utm_source=wpcal_plugin&utm_medium=admin_header"
                  target="_blank"
                  >How to integrate booking widget with front end?</a
                >
              </li>
              <li>
                <a
                  href="https://help.wpcal.io/en/article/how-to-set-different-sizes-for-the-booking-widget-1cf6s2v/?utm_source=wpcal_plugin&utm_medium=admin_header"
                  target="_blank"
                  >How to set different sizes of booking widget?</a
                >
              </li>
              <li>
                <a
                  href="https://help.wpcal.io/?utm_source=wpcal_plugin&utm_medium=admin_et_list"
                  target="_blank"
                  >More help docs.</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <v-dialog /> -->
    <AlertAdminToUpdateProfile
      :service_details="sample_real_service_details"
      v-if="sample_real_service_details && sample_real_service_details.name"
    />
  </div>
</template>

<script>
import OnOffSlider from "@/components/form_elements/OnOffSlider.vue";
import TypeToSelect from "@/components/form_elements/TypeToSelect.vue";
import OverflowMenu from "@/components/form_elements/OverflowMenu.vue";

import AlertAdminToUpdateProfile from "@/components/admin/AlertAdminToUpdateProfile.vue";
import { admin_service_status_toggle_mixin } from "@/utils/admin_service_status_toggle_mixin.js";

import axios from "axios";

export default {
  name: "ServiceList",
  mixins: [admin_service_status_toggle_mixin],
  components: {
    OnOffSlider,
    TypeToSelect,
    AlertAdminToUpdateProfile,
    OverflowMenu
  },
  data() {
    return {
      document_title: this.T__("Event Types"),
      service_list: {},
      saved_service_list: {},
      filter_options: {
        filter_by_admin_id: this.$store.getters.get_current_admin_details.id
      },
      first_time_service_list_loaded: false,
      service_overflow_menu_details: {
        open_menu_id: null,
        popper_instance: null
      },
      delete_highlight_service_id: null
    };
  },
  computed: {
    grouped_service_list() {
      let grouped_service_list = []; //to maintain order array is used
      let unidentified_service_list = []; //mostly deleted admins
      let unidentified_services = []; //mostly deleted admins

      let managed_admins = this.$store.getters
        .get_managed_active_admins_details;
      for (let admin_detail of managed_admins) {
        grouped_service_list.push({
          admin_user_id: admin_detail.admin_user_id,
          services: []
        }); //to maintain order array inside object used
      }

      for (let service of this.service_list_final) {
        let _index = grouped_service_list.findIndex(val => {
          return val.admin_user_id == service.admin_user_id;
        });
        //let _unidentified_list_index;
        if (_index == -1) {
          // _unidentified_list_index = unidentified_service_list.findIndex(
          //   val => {
          //     return val.admin_user_id == service.admin_user_id;
          //   }
          // );
          // if (_unidentified_list_index == -1) {
          //   _unidentified_list_index =
          //     unidentified_service_list.push({
          //       admin_user_id: service.admin_user_id,
          //       services: []
          //     }) - 1;
          // }
          unidentified_services.push(service);
          continue;
        }
        grouped_service_list[_index].services.push(service);
      }

      let grouped_service_list_tmp = this.clone_deep(grouped_service_list);
      grouped_service_list = [];
      for (let val_obj of grouped_service_list_tmp) {
        if (!this._isEmpty(val_obj.services)) {
          grouped_service_list.push(val_obj);
        }
      }
      if (unidentified_services.length) {
        unidentified_service_list[0] = {
          admin_user_id: 0,
          services: this.clone_deep(unidentified_services)
        };
        grouped_service_list = grouped_service_list.concat(
          unidentified_service_list
        );
      }
      return grouped_service_list;
    },
    service_list_final() {
      if (!Array.isArray(this.service_list) || !this.service_list.length) {
        return [];
      }
      let service_list_tmp = this.clone_deep(this.service_list);
      service_list_tmp.sort((a, b) => b.id - a.id); //latest first - decending
      return service_list_tmp;
    },
    sample_real_service_details() {
      let service_details = null;
      if (
        Array.isArray(this.service_list_final) &&
        this.service_list_final.length
      ) {
        for (let service_key in this.service_list_final) {
          if (this.service_list_final[service_key].status == "1") {
            service_details = this.clone_deep(
              this.service_list_final[service_key]
            );
            break;
          }
        }
        if (!service_details) {
          //If non of the service is active
          service_details = this.clone_deep(this.service_list_final[0]);
        }
      }
      return service_details;
    }
  },
  methods: {
    load_page() {
      let action = "get_managed_services_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = this.filter_options;

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            dont_notify_success: true
          });
          if (
            response.data &&
            response.data[action].hasOwnProperty("service_list")
          ) {
            this.service_list = response.data[action].service_list;
            this.saved_service_list = this.clone_deep(this.service_list);
            this.first_time_service_list_loaded = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.load_page();
    this.$store.dispatch("load_managed_active_admins_details");
  }
};
</script>
<style lang="css" scoped>
.ttf-v-selector .vs__dropdown-toggle {
  cursor: pointer;
  line-height: 1.2em;
  border: 1px solid #b1b6d1;
  background-color: #eff3fb;
}
.service-list-cont {
  margin-left: -10px;
  margin-top: 20px;
}

.service-list-cont .service-list-group-admin-profile {
  margin-left: 15px;
  display: flex;
  align-items: center;
  font-family: "RubikMed" !important;
  font-size: 16px;
}
.service-list-cont .service-list-group-admin-profile img {
  margin-right: 10px;
}
.service-list-cont .service-list-singles-cont {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.service-list-cont .service-list-single {
  border: 1px solid #b1b6d1;
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1);
  padding: 10px 10px 7px 15px;
  border-radius: 5px;
  margin: 10px;
  width: 300px;
  background-color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
}
#wpcal_admin_app .service-list-cont .service-list-single.del-alert {
  border-style: solid !important;
}
.service-list-cont .service-list-single.private h4 a i::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 61.25 78.75'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23131336;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M56.88,26.25H52.5V21.88a21.88,21.88,0,1,0-43.75,0v4.37H4.38A4.38,4.38,0,0,0,0,30.62V74.38a4.38,4.38,0,0,0,4.38,4.37h52.5a4.37,4.37,0,0,0,4.37-4.37V30.62A4.37,4.37,0,0,0,56.88,26.25ZM17.5,21.88a13.13,13.13,0,1,1,26.25,0v4.37H17.5ZM52.5,70H8.75V35H52.5Z'/%3E%3Cpath class='cls-1' d='M30.62,46.11a6.56,6.56,0,1,0,6.57,6.56A6.57,6.57,0,0,0,30.62,46.11Zm0,8.75a2.19,2.19,0,1,1,2.19-2.19A2.19,2.19,0,0,1,30.62,54.86Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 10px;
  height: 13px;
  left: 0;
}

.service-list-cont .service-list-single.private h4 a i::after {
  content: "Private";
  display: none;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 11px;
  font-style: normal;
  padding: 1px 3px;
  border-radius: 3px;
  position: absolute;
  margin: -22px 0 0 -32px;
}
.service-list-cont .service-list-single.private h4 a i:hover::after {
  display: inline-block;
}
.service-list-cont .service-list-single.private h4 a {
  position: relative;
  padding-left: 16px;
}

.service-list-cont .service-list-single h4 {
  color: #131336;
  margin: 0;
  font-size: 14px;
  margin-bottom: 5px;
  padding-right: 20px;
}
.service-list-cont .service-list-single h4 a {
  font-family: "RubikMed" !important;
}
.view-booking-page {
  border: 1px solid #567bf3;
  border-radius: 2px;
  padding: 5px 16px 5px 8px;
  text-decoration: none !important;
  font-size: 11px;
  position: relative;
  height: 16px;
}
.view-booking-page::after {
  content: "";
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 7.5 7.5'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23567bf3;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cline class='cls-1' x1='0.75' y1='6.75' x2='6.75' y2='0.75'/%3E%3Cpolyline class='cls-1' points='2.25 0.75 6.75 0.75 6.75 5.25'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  width: 8px;
  height: 8px;
  right: 4px;
}
.view-booking-page:hover {
  background-color: #eff3fb;
}
.service-list-cont .service-list-single.clr-chill {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #1e90ff;
  border-left-color: #1e90ff;
}
.service-list-cont .service-list-single.clr-sunflower {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #f1c40f;
  border-left-color: #f1c40f;
}
.service-list-cont .service-list-single.clr-nephritis {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #27ae60;
  border-left-color: #27ae60;
}
.service-list-cont .service-list-single.clr-carrot {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #e67e22;
  border-left-color: #e67e22;
}
.service-list-cont .service-list-single.clr-belize {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #2980b9;
  border-left-color: #2980b9;
}
.service-list-cont .service-list-single.clr-alizarin {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #e74c3c;
  border-left-color: #e74c3c;
}
.service-list-cont .service-list-single.clr-wisteria {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #8e44ad;
  border-left-color: #8e44ad;
}
.service-list-cont .service-list-single.clr-prunus {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #e84393;
  border-left-color: #e84393;
}
.service-list-cont .service-list-single.clr-midnightblue {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #5f27cd;
  border-left-color: #5f27cd;
}
.service-list-cont .service-list-single.clr-concrete {
  box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.1), inset 4px 0 #95a5a6;
  border-left-color: #95a5a6;
}

.service-list-cont .service-list-single .et-meta {
  color: #7c7d9c !important;
  font-size: 13px;
  margin-bottom: 10px;
}
.service-list-cont .service-list-single h4 a {
  color: #131336 !important;
  font-size: 14px !important;
}
.service-list-cont .service-list-single:hover h4 a {
  text-decoration: underline !important;
}
.service-list-cont .service-list-single.inactive {
  background-color: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(177, 182, 209, 0.5);
}
.service-list-cont .service-list-single.inactive h4,
.service-list-cont .service-list-single.inactive > div {
  opacity: 0.5;
}
.service-list-cont .service-list-single .et-edit-link {
  position: absolute;
  right: 35px;
  padding-left: 10px;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 20%,
    rgba(255, 255, 255, 1) 100%
  );
  display: none;
}
.service-list-cont .service-list-single:hover .et-edit-link {
  display: block;
}
.et-filter-cont {
  border: 1px solid #b1b6d1;
  background-color: #fff;
  border-radius: 5px;
  display: inline-flex;
  width: auto;
}
.help-column {
  width: 170px;
  min-width: 170px;
  margin: 0 20px;
  margin-left: auto;
}
</style>
